module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newWorkOrder"
    }
  }, [_c('el-col', {
    staticClass: "clearfix searthPart"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "headerT fl",
    staticStyle: {
      "width": "90px",
      "margin-top": "0"
    }
  }, [_vm._v("工单信息")]), _vm._v(" "), (_vm.orderInfoForm.isTag == 0) ? _c('i', {
    staticClass: "el-icon-star-off fl",
    staticStyle: {
      "font-size": "20px",
      "margin-left": "20px"
    },
    on: {
      "click": function($event) {
        _vm.orderInfoForm.isTag = 1
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.isTag == 1) ? _c('i', {
    staticClass: "el-icon-star-on fl StarOn",
    staticStyle: {
      "font-size": "20px",
      "margin-left": "20px",
      "margin-top": "16px"
    },
    on: {
      "click": function($event) {
        _vm.orderInfoForm.isTag = 0
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.orderInfoForm,
      "label-width": "80px",
      "label-position": _vm.labelPosition
    }
  }, [_c('ul', {
    staticClass: "item-content"
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "工单类型",
      "prop": "serviceType"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择工单类型"
    },
    on: {
      "change": _vm.selectOrderType
    },
    model: {
      value: (_vm.orderInfoForm.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "serviceType", $$v)
      },
      expression: "orderInfoForm.serviceType"
    }
  }, _vm._l((_vm.orderTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.orderInfoForm.serviceType == 'SS' || _vm.orderInfoForm.serviceType == 'DS' || _vm.orderInfoForm.serviceType == 'QS') ? _c('li', {
    staticClass: "orginal",
    attrs: {
      "prop": "originalOrderNo"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原始工单",
      "prop": "originalOrderNo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.originalOrderNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "originalOrderNo", $$v)
      },
      expression: "orderInfoForm.originalOrderNo"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    staticStyle: {
      "font-size": "24px"
    },
    on: {
      "click": function($event) {
        return _vm.searchOldOrder()
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "渠道来源",
      "prop": "orderIdentifier"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择渠道来源"
    },
    on: {
      "change": _vm.chosePayFlag
    },
    model: {
      value: (_vm.orderInfoForm.orderIdentifier),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderIdentifier", $$v)
      },
      expression: "orderInfoForm.orderIdentifier"
    }
  }, _vm._l((_vm.sourceForList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "渠道类型",
      "prop": "orderIdentifier"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择渠道类型"
    },
    model: {
      value: (_vm.orderInfoForm.channelType),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "channelType", $$v)
      },
      expression: "orderInfoForm.channelType"
    }
  }, _vm._l((_vm.channelTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "bookTime"
  }, [_c('el-form-item', {
    attrs: {
      "label": "预约时间",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "130px",
      "font-size": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "日期"
    },
    model: {
      value: (_vm.orderInfoForm.onsiteDate),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "onsiteDate", $$v)
      },
      expression: "orderInfoForm.onsiteDate"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "110px",
      "font-size": "10px"
    },
    attrs: {
      "placeholder": "起始",
      "picker-options": {
        start: '9:00',
        step: '01:00',
        end: '22:00',
        maxTime: _vm.orderInfoForm.onsiteTimeEnd
      }
    },
    model: {
      value: (_vm.orderInfoForm.onsiteTimeStart),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "onsiteTimeStart", $$v)
      },
      expression: "orderInfoForm.onsiteTimeStart"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "110px",
      "font-size": "10px"
    },
    attrs: {
      "placeholder": "结束",
      "picker-options": {
        start: '9:00',
        step: '01:00',
        end: '22:00',
        minTime: _vm.orderInfoForm.onsiteTimeStart
      }
    },
    model: {
      value: (_vm.orderInfoForm.onsiteTimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "onsiteTimeEnd", $$v)
      },
      expression: "orderInfoForm.onsiteTimeEnd"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "item-content"
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "placeholder": "请输入姓名（不超过30字）"
    },
    model: {
      value: (_vm.orderInfoForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "customerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.customerName"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "telephoneNo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "20",
      "type": "text",
      "onKeypress": "return (/[\\d]/.test(String.fromCharCode(event.keyCode)))"
    },
    model: {
      value: (_vm.orderInfoForm.telephoneNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "telephoneNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.telephoneNo"
    }
  })], 1)], 1), _vm._v(" "), (_vm.orderInfoForm.serviceType != 'DD' && _vm.orderInfoForm.serviceType != 'DS') ? _c('li', {
    staticClass: "location"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "地址",
      "required": ""
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "prop": "provinceId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "省"
    },
    on: {
      "change": _vm.choseProvince
    },
    model: {
      value: (_vm.provinceId),
      callback: function($$v) {
        _vm.provinceId = $$v
      },
      expression: "provinceId"
    }
  }, _vm._l((_vm.provinceList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "prop": "cityId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "市"
    },
    on: {
      "change": _vm.choseCity
    },
    model: {
      value: (_vm.cityId),
      callback: function($$v) {
        _vm.cityId = $$v
      },
      expression: "cityId"
    }
  }, _vm._l((_vm.cityList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "prop": "areaId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "区"
    },
    on: {
      "change": _vm.choseBlock
    },
    model: {
      value: (_vm.areaId),
      callback: function($$v) {
        _vm.areaId = $$v
      },
      expression: "areaId"
    }
  }, _vm._l((_vm.areaList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "15%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "prop": "streetId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "街道"
    },
    on: {
      "change": _vm.choseStreet
    },
    model: {
      value: (_vm.streetId),
      callback: function($$v) {
        _vm.streetId = $$v
      },
      expression: "streetId"
    }
  }, _vm._l((_vm.streetList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.orderInfoForm.serviceType != 'DD' && _vm.orderInfoForm.serviceType != 'DS') ? _c('el-form-item', {
    staticStyle: {
      "width": "40%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "label-width": "0",
      "prop": "address"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "clearable": "",
      "maxlength": 200,
      "placeholder": "详细地址（不超过200字）"
    },
    model: {
      value: (_vm.orderInfoForm.address),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.address"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.serviceType == 'DD' || _vm.orderInfoForm.serviceType == 'DS') ? _c('li', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "门店",
      "prop": "shopId",
      "label-width": "50px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择门店"
    },
    on: {
      "change": _vm.selectShop
    },
    model: {
      value: (_vm.orderInfoForm.shopId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "shopId", $$v)
      },
      expression: "orderInfoForm.shopId"
    }
  }, _vm._l((_vm.shopDataList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfoForm.serviceType == 'DD' || _vm.orderInfoForm.serviceType == 'DS') ? _c('li', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "工程师",
      "label-width": "70px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择门店工程师"
    },
    model: {
      value: (_vm.orderInfoForm.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "engineerId", $$v)
      },
      expression: "orderInfoForm.engineerId"
    }
  }, _vm._l((_vm.engineerDataList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "item-content"
  }, [_c('li', {
    staticClass: "memo"
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "maxlength": 400,
      "type": "text",
      "placeholder": "请输入备注信息（不超过400字）"
    },
    model: {
      value: (_vm.orderInfoForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.remark"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.isDianShangBanDan) ? _c('div', {
    staticClass: "dashLine"
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("销售信息")])]) : _vm._e(), _vm._v(" "), (_vm.isDianShangBanDan) ? _c('ul', {
    staticClass: "item-content",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "销售单号",
      "prop": "saleOrderNo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "placeholder": "请输入销售单号"
    },
    model: {
      value: (_vm.orderInfoForm.saleOrderNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "saleOrderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.saleOrderNo"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "商品SKU",
      "prop": "saleGoodsSku"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "placeholder": "请输入销售商户SKU"
    },
    model: {
      value: (_vm.orderInfoForm.saleGoodsSku),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "saleGoodsSku", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.saleGoodsSku"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "销售金额",
      "prop": "saleActualAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "placeholder": "请输入实收金额"
    },
    model: {
      value: (_vm.orderInfoForm.saleActualAmount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "saleActualAmount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.saleActualAmount"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('ul', {
    staticClass: "item1-content"
  }, [_c('li', [_c('el-form-item', {
    attrs: {
      "label": "品牌",
      "prop": "brandId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择品牌"
    },
    on: {
      "change": _vm.choseBrand
    },
    model: {
      value: (_vm.orderInfoForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "brandId", $$v)
      },
      expression: "orderInfoForm.brandId"
    }
  }, _vm._l((_vm.brandList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    }, [_vm._v("\n                " + _vm._s(item.brandName) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "品类",
      "prop": "categoryId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择品类"
    },
    on: {
      "change": _vm.choseCategory
    },
    model: {
      value: (_vm.orderInfoForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "categoryId", $$v)
      },
      expression: "orderInfoForm.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "型号",
      "prop": "modelId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择型号"
    },
    on: {
      "change": _vm.choseModel
    },
    model: {
      value: (_vm.orderInfoForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "modelId", $$v)
      },
      expression: "orderInfoForm.modelId"
    }
  }, _vm._l((_vm.modelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label": "颜色",
      "prop": "colorId",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择颜色"
    },
    on: {
      "change": _vm.choseColor
    },
    model: {
      value: (_vm.orderInfoForm.colorId),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "colorId", $$v)
      },
      expression: "orderInfoForm.colorId"
    }
  }, _vm._l((_vm.colorList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.colorName,
        "value": item.colorId
      }
    }, [_vm._v(_vm._s(item.colorName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label-width": "60px",
      "label": "金额",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.price),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "price", $$v)
      },
      expression: "orderInfoForm.price"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-form-item', {
    attrs: {
      "label-width": "60px",
      "label": "渠道",
      "prop": "partChannel"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择退款状态",
      "clearable": ""
    },
    model: {
      value: (_vm.partChannel),
      callback: function($$v) {
        _vm.partChannel = $$v
      },
      expression: "partChannel"
    }
  }, _vm._l((_vm.channelTypeLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "fl clearfix",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障分类",
      "prop": "faultClass"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.faultTypeCheckList),
      callback: function($$v) {
        _vm.faultTypeCheckList = $$v
      },
      expression: "faultTypeCheckList"
    }
  }, _vm._l((_vm.faultTypeList), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.faultTypesId,
        "name": ""
      },
      on: {
        "change": function($event) {
          return _vm.chooseFaultType(item)
        }
      }
    }, [_vm._v(_vm._s(item.faultTypesName))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "fr clearfix",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障",
      "prop": "故障"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.faultSubCheckList),
      callback: function($$v) {
        _vm.faultSubCheckList = $$v
      },
      expression: "faultSubCheckList"
    }
  }, _vm._l((_vm.faultSubclassList), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.faultSubclassId,
        "name": item.faultSubclassId
      },
      on: {
        "change": function($event) {
          return _vm.chooseFaultSubclass(item)
        }
      }
    }, [_vm._v(_vm._s(item.faultSubclassName) + _vm._s(item.price) + "元")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "客服备注",
      "prop": "handleRemark"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "maxlength": 400,
      "type": "text",
      "placeholder": "请输入备注信息（不超过400字）"
    },
    model: {
      value: (_vm.orderInfoForm.handleRemark),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "handleRemark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.handleRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "dashLine"
  }), _vm._v(" "), _c('p', {
    staticClass: "headerT clearfix"
  }, [_vm._v("支付信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "110px",
      "label": "应付金额（元）",
      "prop": "amountPayable"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.amountPayable),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "amountPayable", $$v)
      },
      expression: "orderInfoForm.amountPayable"
    }
  }, [_vm._v(_vm._s(_vm.orderInfoForm.faultPrice *
    _vm.orderInfoForm.discount))])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-switch', {
    staticStyle: {
      "display": "block",
      "margin-top": "10px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-text": "收款",
      "inactive-text": "不收款",
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: (_vm.orderInfoForm.payFlag),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "payFlag", $$v)
      },
      expression: "orderInfoForm.payFlag"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "85px",
      "label": "定金（元）",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入金额",
      "oninput": "this.value=this.value.replace(/\\D/g,'').replace(/^0{1,}/g,'')",
      "maxlength": "4"
    },
    model: {
      value: (_vm.orderInfoForm.earnest),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "earnest", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.earnest"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "50px",
      "label": "折扣",
      "prop": "discount"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择折扣1",
      "clearable": ""
    },
    on: {
      "change": _vm.changeDisCount
    },
    model: {
      value: (_vm.orderInfoForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "discount", $$v)
      },
      expression: "orderInfoForm.discount"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "9.5",
      "value": "9.5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "9",
      "value": "9"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "8.5",
      "value": "8.5"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dislogCreate,
      "close-on-click-modal": false,
      "width": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogCreate = $event
      },
      "close": function($event) {
        return _vm.emptyDialog()
      }
    }
  }, [_c('el-form', {
    ref: "oldorderForm",
    attrs: {
      "model": _vm.originOrder,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-select', {
    staticClass: "fl",
    staticStyle: {
      "width": "100px",
      "margin-right": "20px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择内容"
    },
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "手机号",
      "value": "tel"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "订单号",
      "value": "ono"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户名",
      "value": "cna"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "fl",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.searchWord),
      callback: function($$v) {
        _vm.searchWord = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "searchWord"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.selectAfterOpe()
      }
    }
  }, [_vm._v("检索")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.afterOrderPageList,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderNo",
      "label": "工单编号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "型号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.modelName) + " " + _vm._s(scope.row.colorName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "fault",
      "label": "故障"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.faultSubclass), function(item, index) {
          return _c('span', {
            key: index
          }, [(item != null && item.faultSubclassName != null) ? _c('span', [_vm._v(_vm._s(item.faultSubclassName))]) : _vm._e()])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "label": "维修时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("date")(scope.row.createTime)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "userInfo",
      "label": "客户信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.customerName) + " " + _vm._s(scope.row.telephoneNo) + " " + _vm._s(scope.row.address))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "afterCount",
      "label": "售后次数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.selectCode(scope.row)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.originOrder.startRow,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.originOrder.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px",
      "margin-bottom": "30px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createOrder('orderInfoForm')
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createM3Order('orderInfoForm')
      }
    }
  }, [_vm._v("确认并转M4")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-4d69ed24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/newWorkOrder.vue
// module id = 1664
// module chunks = 0